
import { Component, Vue } from 'vue-property-decorator';
import CampaignPopup from './CampaignPopup.vue';
@Component({ components: { CampaignPopup } })
export default class CampaignsPopup extends Vue {
  closedCampaignIds: string[] = [];

  onClose(id: string) {
    this.closedCampaignIds.push(id);
  }
}
